module.exports = __webpack_public_path__ + "static/media/27.acf62a30.JPG";